// src/pages/TplinkAlexaGoogle.jsx
import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function TplinkAlexaGoogle() {
  return (
    <div className="min-h-screen bg-[#111111] text-white scroll-smooth">
      <Helmet>
        <title>TP-Link | Alexa & Google Assistant | SeguraTech</title>
        <meta
          name="description"
          content="Control your TP-Link Tapo smart home hands-free with Alexa and Google Assistant. Seamless integration for effortless automation."
        />
        <meta property="og:title" content="TP-Link Alexa & Google Assistant | SeguraTech" />
        <meta
          property="og:description"
          content="Voice control and seamless integration with Alexa and Google Assistant for your TP-Link Tapo smart home."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.seguratech.co.uk/tplink/alexa-google" />
        <meta property="og:image" content="/tplink-logo.png" />
      </Helmet>

      {/* Hero Section */}
      <section className="max-w-5xl mx-auto px-4 py-20 text-center">
        <h1 className="text-4xl md:text-6xl font-extrabold text-[#C6A564] mb-6">
          Alexa & Google Assistant
        </h1>
        <p className="text-lg text-white/80 max-w-3xl mx-auto">
          Voice control and seamless integration for hands-free automation.  
          Manage your TP-Link Tapo devices effortlessly using simple, secure commands.
        </p>
      </section>

      {/* Feature Boxes */}
      <section className="max-w-6xl mx-auto px-4 pb-24 grid md:grid-cols-2 gap-10">
        {/* Box 1: Hands-Free Voice Control */}
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col justify-between">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
            Hands-Free Voice Control
          </h3>
          <p className="text-white/80 text-center leading-relaxed">
            Voice control with Google Assistant and Alexa transforms everyday living.<br /><br />
            Simply speak to manage lights, cameras, and appliances effortlessly.<br /><br />
            No more switching apps or reaching for your phone 
            just smooth, instant control whenever you need it.<br /><br />
            Ideal for multitasking or accessibility, hands free commands boost convenience,<br />
            safety, and efficiency throughout your smart home.<br /><br />
            A seamless way to simplify routines and elevate modern living.
          </p>
        </div>

        {/* Box 2: Seamless Integration */}
        <div className="border border-[#C6A564] rounded-2xl p-8 bg-[#1a1a1a] hover:bg-[#222222] transition flex flex-col justify-between">
          <h3 className="text-2xl font-semibold text-[#C6A564] mb-4 text-center">
            Seamless Integration
          </h3>
          <p className="text-white/80 text-center leading-relaxed">
            TP-Link’s Tapo devices integrate flawlessly with Alexa and Google Home,<br />
            syncing instantly for effortless control across your entire home.<br /><br />
            Through the Tapo app, linking takes seconds
            then all devices respond naturally to your voice or routines.<br /><br />
            Integration runs locally where possible for faster response and reliability,<br />
            ensuring your automation stays secure, smooth, and always connected.<br /><br />
            True simplicity through unified smart home design.
          </p>
        </div>
      </section>

      {/* Back Link */}
      <div className="text-center pb-16">
        <Link
          to="/tplink"
          className="text-[#C6A564] hover:text-[#E7D7B0] transition underline"
        >
          ← Back to TP-Link Overview
        </Link>
      </div>
    </div>
  );
}
